import React from "react";
import LineChart from "./sub-components/LineChart";
import OrderChart from "./sub-components/OrderChart";
import EndingCards from "./sub-components/EndingCard";
import DueCards from "./DueCards";

const linedata = [
    ["Year", "Sales", "Expenses", "Profit"],
    ["", 1000, 400, 300],
    ["", 1170, 460, 879],
    ["", 660, 1120, 777],
    ["", 1030, 540, 666],
];

const weightData = (orderData) => {
    return [
        ["Quantity", "Weight"],
        [orderData?.single?.val, orderData?.single?.wt],
        [orderData?.upto_5?.val, orderData?.upto_5?.wt],
        [(orderData?.above_6 ? orderData?.above_6?.val :  0), (orderData?.above_6 ? orderData?.above_6?.wt : 0)]
    ]
}

const weightOptions = {
    title: "Weight Trend By Quantity",
    backgroundColor: '#343a40',
    titleTextStyle: {fontSize: 0, color: 'transparent'},
    hAxis: {
        title: 'Quantity', textStyle: {color: '#E0E0E0'},
        titleTextStyle: {color: '#E0E0E0'}
    },
    vAxis: {
        title: 'Weight', textStyle: {color: '#E0E0E0'},
        titleTextStyle: {color: '#E0E0E0'}
    },
    legend: 'none',
    colors: ['#4285F4']
}

const valueData = (orderData) => {
    return [
        ["Count", "Weight"],
        [orderData?.under_100?.val, orderData?.under_100?.wt],
        [(orderData?.over_500 ? orderData?.over_500?.val : 0), (orderData?.over_500 ? orderData?.over_500?.wt : 0)],
        [(orderData?.over_1000 ? orderData?.over_1000?.val : 0), (orderData?.over_1000 ? orderData?.over_1000?.wt : 0)],
        [(orderData?.over_5000 ? orderData?.over_5000?.val : 0), (orderData?.over_5000 ? orderData?.over_5000?.wt : 0)],
        [(orderData?.over_10000 ? orderData?.over_10000.val : 0), (orderData?.over_10000 ? orderData?.over_10000?.wt : 0)]
    ]
}

const valueOptions = {
    title: "Value Trend by Count",
    backgroundColor: '#343a40',
    hAxis: {title: "Count", textStyle: {color: '#E0E0E0'},
        titleTextStyle: {color: '#E0E0E0'}},
    vAxis: {title: 'Value ($)', textStyle: {color: '#E0E0E0'},
        titleTextStyle: {color: '#E0E0E0'}},
    legend: 'none',
    colors: ['#DB4437']
}

const options = {
    title: "Order Trends",
    backgroundColor: '#343a40',
    titleTextStyle: {color: '#FFF'},
    hAxis: {
        title: "Quantity / Count (val)",
        textStyle: {color: '#E0E0E0'},
        titleTextStyle: {color: '#E0E0E0'},
    },
    vAxis: {
        title: "Amount",
        textStyle: {color: '#E0E0E0'},
        titleTextStyle: {color: '#E0E0E0'},
    },
    series: {
        0: {color: '#4285F4'}, // Blue
        1: {color: '#DB4437'}, // Red
    },
    interpolateNulls: false,
};

const Ebay = ({
                  dueData,
                  isDueDataLoading,
                  endingData,
                  isEndingDataLoading,
                  orderData,
                  isOrderDataLoading,
                  pickedData,
                  isPickedDataLoading,
              }) => {
    return (
        <div>
            <p className="secondHeader">eBay</p>
            <EndingCards
                endingData={endingData}
                isEndingDataLoading={isEndingDataLoading}
            />
            <DueCards
                dueData={dueData}
                isDueDataLoading={isDueDataLoading}
                pickedData={pickedData?.rows}
                isPickedDataLoading={isPickedDataLoading}
            />
            <LineChart data={weightData(orderData)} options={weightOptions}/>
            <LineChart data={valueData(orderData)} options={valueOptions}/>
            <OrderChart
                orderData={orderData}
                isOrderDataLoading={isOrderDataLoading}
            />
        </div>
    );
};

export default React.memo(Ebay);
